import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/system';

export type CornerBannerProps = {
  children: React.ReactNode;
  text?: React.ReactNode;
  show?: boolean;
  ariaLabel?: string;
};

export function CornerBanner({ children, text, show, ariaLabel }: CornerBannerProps) {
  const isVisible = show ?? (text !== undefined && text !== null && text !== '');

  return (
    <Box
      component="span"
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
      }}
    >
      {children}
      {isVisible && (
        <Box
          component="span"
          sx={{
            position: 'absolute',
            zIndex: 1,
            top: 0,
            right: 0,
            transform: 'translate(20%, -25%)',
            pointerEvents: 'none',
            bgcolor: (theme) =>
              theme.vars
                ? `rgba(${theme.vars.palette.error.lightChannel} / 0.7)`
                : alpha(theme.palette.error.light, 0.7),
            color: 'error.contrastText',
            borderRadius: 1,
            px: 0.75,
            py: 0.25,
            boxShadow: 1,
            whiteSpace: 'nowrap',
          }}
        >
          <Typography
            component="span"
            variant="caption"
            sx={{ fontSize: 12, fontWeight: 700, lineHeight: 1, letterSpacing: 0.2 }}
            aria-label={ariaLabel}
            role={ariaLabel ? 'status' : undefined}
          >
            {text}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
